import React, { useState, useCallback, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Button,
  Box,
  Snackbar,
  Alert,
  Avatar,
} from '@mui/material';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuIcon from '@mui/icons-material/Menu';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import StpLogo from '../assets/Logo_Color_Training.png';
import TikTokLogo from '../assets/TikTokSTP.png'
import axios from 'axios';

import useLangStore from '../store/langStore';
import useUserStore from '../store/UserStore';

import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { logout } from '../services/logout';
import { STPButton } from './Botones';
import CertificationsModal from './CertificationsModal';
import ComingSoonModal from './ComingSoonModal';
import PropTypes from 'prop-types';

export const Header = ({ setIsAuthenticated }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { lang, setLang, alertOpen, setAlertOpen } = useLangStore(state => ({ lang: state.lang, setLang: state.setLang, alertOpen: state.alertOpen, setAlertOpen: state.setAlertOpen }));
  const { t, i18n } = useTranslation();
  const userSelected = localStorage.getItem('IdPersona_selected');

  const location = useLocation();
  const [isUserLoged, setIsUserLoged] = useState(false);

  const { user, setUser } = useUserStore(state => ({
    user: state.user,
    setUser: state.setUser
  }));

  const userImage = localStorage.getItem('userImage');

  const userData = {
    nom: localStorage.getItem('userData_nom'),
    cognoms: localStorage.getItem('userData_cognoms')
  };

  const [menuItems, setMenuItems] = useState([
    { text: t("menuItems.nosaltres"), route: '/nosaltres', external: true },
    { text: 'Onlive', onClick: () => { setComingSoonMsg(t('comingSoon.onliveMsg', 'Training Onlive estará disponible próximamente.')); setComingSoonOpen(true); }, color: '#Cc3026' },
    { divider: true },
    { text: t("menuItems.generalData"), route: '/general-data' },
    { text: t("menuItems.attendance"), route: '/attendance' },
    { text: t("menuItems.evaluation"), route: '/evaluation' },
    { text: t("menuItems.news"), route: '/news' },
    { text: t("menuItems.receipts"), route: '/receipts' },
    { divider: true },
    { text: t("menuItems.calendar"), route: '/calendar' },
    { text: t("menuItems.language"), action: 'toggleLanguage' },
    { text: t("menuItems.location"), route: '/location' },
    { text: t("menuItems.contact"), route: '/contact' },
    { text: t("menuItems.logout"), action: 'logout' }
  ]);

  const [certificationDialogOpen, setCertificationDialogOpen] = useState(false);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [comingSoonMsg, setComingSoonMsg] = useState('');

  const getMenuItems = useCallback((isUserLoged) => {
    if (isUserLoged) {
      return [
        { text: t("menuItems.nosaltres"), route: '/nosaltres', external: true },
        { text: 'Onlive', onClick: () => { setComingSoonMsg(t('comingSoon.onliveMsg', 'Training Onlive estará disponible próximamente.')); setComingSoonOpen(true); }, color: '#Cc3026' },
        { text: t("menuItems.certifications"), action: 'certifications', onClick: () => setCertificationDialogOpen(true) },
        { divider: true },
        { text: t("menuItems.generalData"), route: '/general-data' },
        { text: t("menuItems.attendance"), route: '/attendance' },
        { text: t("menuItems.evaluation"), route: '/evaluation' },
        { text: t("menuItems.news"), route: '/news' },
        { text: t("menuItems.receipts"), route: '/receipts' },
        { text: t("home.menuItems.recurseBank"), route: '/recursos' },
        { divider: true },
        { text: t("menuItems.calendar"), route: '/calendar' },
        { text: t("menuItems.language"), action: 'toggleLanguage' },
        { text: t("menuItems.location"), route: '/location' },
        { text: t("menuItems.contact"), route: '/contact' },
        { text: t("menuItems.logout"), action: 'logout' }
      ];
    } else {
      return [
        { text: t("menuItems.home"), route: '/welcome' },
        { text: t("menuItems.nosaltres"), route: '/nosaltres', external: true },
        { text: 'Onlive', onClick: () => { setComingSoonMsg(t('comingSoon.onliveMsg', 'Training Onlive estará disponible próximamente.')); setComingSoonOpen(true); }, color: '#Cc3026' },
        { text: t("menuItems.certifications"), action: 'certifications', onClick: () => setCertificationDialogOpen(true) },
        { divider: true },
        { text: t("menuItems.testLevel"), route: '/test-nivell', external: true },
        { text: t("menuItems.ourCourses"), route: '/welcome', section: 'cursos' },
        { text: t("menuItems.newsNetwork"), route: '/news' },
        { divider: true },
        { divider: true },
        { divider: true },
        { text: t("menuItems.language"), action: 'toggleLanguage' },
        { text: t("menuItems.location"), route: '/location' },
        { text: t("menuItems.contact"), route: '/contact' },
      ];
    }
  }, [t, setCertificationDialogOpen]);

  const handleCertificationClick = () => {
    setCertificationDialogOpen(true);
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await axios.get(`${import.meta.env.VITE_APP_API_URL}protected`, { withCredentials: true });

        setMenuItems([
          { text: t("menuItems.nosaltres"), route: '/nosaltres', external: true },
          { text: 'Onlive', onClick: () => { setComingSoonMsg(t('comingSoon.onliveMsg', 'Training Onlive estará disponible próximamente.')); setComingSoonOpen(true); }, color: '#Cc3026' },
          { text: t("menuItems.certifications"), action: 'certifications', onClick: () => setCertificationDialogOpen(true) },
          { divider: true },
          { text: t("menuItems.generalData"), route: '/general-data' },
          { text: t("menuItems.attendance"), route: '/attendance' },
          { text: t("menuItems.evaluation"), route: '/evaluation' },
          { text: t("menuItems.news"), route: '/news' },
          { text: t("menuItems.receipts"), route: '/receipts' },
          { text: t("home.menuItems.recurseBank"), route: '/recursos' },
          { divider: true },
          { text: t("menuItems.calendar"), route: '/calendar' },
          { text: t("menuItems.language"), action: 'toggleLanguage' },
          { text: t("menuItems.location"), route: '/location' },
          { text: t("menuItems.contact"), route: '/contact' },
          { text: t("menuItems.logout"), action: 'logout' }
        ]);

        setIsUserLoged(true);

      } catch (error) {
        setIsUserLoged(false);

        setMenuItems([
          { text: t("menuItems.home"), route: '/welcome' },
          { text: t("menuItems.nosaltres"), route: '/nosaltres', external: true },
          { text: 'Onlive', onClick: () => { setComingSoonMsg(t('comingSoon.onliveMsg', 'Training Onlive estará disponible próximamente.')); setComingSoonOpen(true); }, color: '#Cc3026' },
          { text: t("menuItems.certifications"), action: 'certifications', onClick: () => setCertificationDialogOpen(true) },
          { divider: true },
          { text: t("menuItems.testLevel"), route: '/test-nivell', external: true },
          { text: t("menuItems.ourCourses"), route: '/welcome', section: 'cursos' },
          { text: t("menuItems.newsNetwork"), route: '/news' },
          { divider: true },
          { divider: true },
          { divider: true },
          { text: t("menuItems.language"), action: 'toggleLanguage' },
          { text: t("menuItems.location"), route: '/location' },
          { text: t("menuItems.contact"), route: '/contact' },
        ])
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [location.pathname, t]);

  const handleUserClick = useCallback(() => {
    setUser({ idpersona: '', email: user.email });
    navigate('/users');
  }, [navigate, setUser, user.email]);

  const handleMenuItemClick = useCallback((item) => {
    if (item.onClick) {
      item.onClick();
      setDrawerOpen(false);
      return;
    }
    if (item.external) {
      if (!isUserLoged) {
        if (item.route === "/nosaltres") {
          window.open('https://www.vilatraining.cat/nosaltres', '_blank', 'noopener');
        }
        else if (item.route === "/test-nivell") {
          window.open("https://www.vilatraining.cat/tests-de-nivell/", '_blank', 'noopener');
        }
        else if (item.route === "/onlive") {
          window.open('https://trainingonlive.vilatraining.cat/', '_blank', 'noopener');
        }
      } else {
        if (item.route === "/nosaltres") {
          window.location.href = 'https://www.vilatraining.cat/nosaltres';
        }
        else if (item.route === "/test-nivell") {
          window.location.href = "https://www.vilatraining.cat/tests-de-nivell/";
        }
        else if (item.route === "/onlive") {
          window.location.href = 'https://trainingonlive.vilatraining.cat/';
        }
      }
    } else if (item.route) {
      if (item.section) {
        navigate(item.route);
        // Esperar a que la navegación termine y luego hacer scroll
        setTimeout(() => {
          const element = document.getElementById(item.section);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        navigate(item.route);
      }
    } else if (item.action === 'toggleLanguage') {
      setLang(lang === 'es_ES' ? 'ca_ES' : 'es_ES')
      setAlertOpen(true);

    } else if (item.action === 'logout') {
      setIsAuthenticated(false);
      localStorage.clear();
      logout(user.email)
        .then(() => {
          navigate('/welcome');
        })
        .catch((error) => {
          console.error('Error logging out:', error);
        });
    } else if (item.action === 'certifications') {
      handleCertificationClick();
    }
    setDrawerOpen(false);
  }, [navigate, setLang, lang, setIsAuthenticated, setAlertOpen, isUserLoged]);

  const formattedUserName = React.useMemo(() => {
    if (userData.nom && userData.cognoms) {
      const fullName = `${userData.nom} ${userData.cognoms}`;
      return fullName.length < 14
        ? `${fullName}.`
        : `${userData.nom.slice(0, 12)} ${userData.cognoms.charAt(0)}.`;
    }
    return ' ';
  }, [userData.nom, userData.cognoms]);

  // Actualizar menuItems cuando cambie el idioma o el estado de login
  useEffect(() => {
    setMenuItems(getMenuItems(isUserLoged));
  }, [t, i18n.language, isUserLoged, getMenuItems]);

  return (
    <Box sx={{ backgroundColor: 'white' }}>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert onClose={() => setAlertOpen(false)} severity="success" sx={{ width: '100%' }}>
          {t('header.languageChanged')}
        </Alert>
      </Snackbar>

      <AppBar
        position="static"
        sx={{
          backgroundColor: 'white',
          height: '100px',
          boxShadow: 'none',
          borderBottom: '2px solid #50A579'
        }}
      >
        <Toolbar
          sx={{
            height: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingX: { xs: 1, sm: 2 }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={StpLogo}
              alt="VilaTraining Logo"
              style={{ height: '55px', cursor: 'pointer' }}
              onClick={userSelected ? () => navigate('/home') : () => navigate('/welcome')}
            />
          </Box>

          {isLoading ? null : isUserLoged ? (
            <IconButton
              onClick={handleUserClick}
              size="small"
              sx={{ color: '#50A579', cursor: 'pointer' }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  maxWidth: '80%'
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 'bold', mr: 1, mt: 1, color: 'black' }}
                >
                  {t("menuItems.user")}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 'bold', mr: 1, color: 'black' }}
                >
                  {formattedUserName}
                </Typography>
              </Box>
              <ArrowDropDownIcon fontSize='large' />
            </IconButton>
          ) : (
            <STPButton
              variant="contained"
              color="primary"
              sx={{ textTransform: 'none' }}
              onClick={() => navigate('/login')}
            >
              {t('menuItems.login')}
            </STPButton>
            )
          }

          <IconButton
            edge="end"
            aria-label="menu"
            onClick={() => setDrawerOpen(true)}
            sx={{ color: '#50A579', cursor: 'pointer', mr: { xs: '5px', sm: '10px' } }}
          >
            <MenuIcon fontSize="large" />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box
          sx={{
            width: 250,
            backgroundColor: '#e8f5e9',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'auto',
            alignItems: 'center',
            paddingY: 2
          }}
          role="presentation"
        >
          {isUserLoged ? <Box sx={{ textAlign: 'center', mb: 2, mt: 3 }}>
            <Avatar
              src={userImage ?? ''}
              alt={`${userData.nom} ${userData.cognoms}`}
              sx={{ width: 80, height: 80, margin: 'auto' }}
            />
            <Typography variant="h6" sx={{ mt: 1, fontSize: '1rem' }}>
              {userData.nom}
            </Typography>
          </Box> : null}
          <List sx={{ width: '100%', paddingX: 1 }}>
            {menuItems.map((item, index) => (
              item.divider ? (
                <Box
                  sx={{ height: 10, backgroundColor: '#e8f5e9' }}
                  key={`divider-${index}`}
                />
              ) : (
                <ListItemButton
                  key={`menu-item-${index}`}
                  onClick={() => handleMenuItemClick(item)}
                  sx={{
                    paddingY: 1,
                    '&:hover': { backgroundColor: item.disabled ? 'inherit' : '#50A579' },
                    opacity: item.disabled ? 0.5 : 1,
                    cursor: item.disabled ? 'not-allowed' : 'pointer',
                  }}
                >
                  {item.icon && <span style={{ marginRight: 8, display: 'inline-flex', alignItems: 'center' }}>{item.icon}</span>}
                  <ListItemText primary={item.text} sx={{ color: item.color }} />
                </ListItemButton>
              )
            ))}
          </List>
          <Box
            sx={{
              padding: 2,
              mt: 'auto',
              borderTop: '1px solid #50A579',
              display: 'flex',
              justifyContent: 'space-around',

            }}
          >
            <IconButton
              onClick={() => window.open('https://www.facebook.com/VilaTraining')}
              aria-label="Facebook"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              onClick={() => window.open('https://www.instagram.com/vila_training/')}
              aria-label="Instagram"
            >
              <InstagramIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: 2, textAlign: 'center', width: '100%' }}>
            <Button
              sx={{ mb: 2, backgroundColor: '#50A579', textTransform: 'none' }}
              variant="contained"
              onClick={() => window.open('https://g.co/kgs/18QAoAd')}
            >
              {t("menuItems.rateUs")}
            </Button>
          </Box>
        </Box>
      </Drawer>

      <CertificationsModal open={certificationDialogOpen} onClose={() => setCertificationDialogOpen(false)} />
      <ComingSoonModal open={comingSoonOpen} onClose={() => setComingSoonOpen(false)} message={comingSoonMsg} />
    </Box>
  );
};

Header.propTypes = {
  setIsAuthenticated: PropTypes.func.isRequired
};
